<template>
  <!-- modal -->
  <div class="dimed wrap">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.Membership.Check.msg1') }}</div>
        <div class="ft-point">{{ $t('Modal.Membership.Check.msg2') }}</div>
      </div>
      <div class="layer__body">
        <div class="flex-row">
          <div class="lyr-center">
            <div class="lst-order--cash">
              <dl>
                <dt>{{ $t('Modal.Membership.Check.msg3') }}</dt>
                <dd>{{ membersObj.point.CUST_NM }}</dd>
              </dl>
              <dl>
                <dt>{{ $t('Modal.Membership.Check.msg4') }}</dt>
                <dd>{{ membersObj.point.Level }}</dd>
              </dl>
              <dl class="point">
                <dt>{{ $t('Modal.Membership.Check.msg5') }}</dt>
                <dd>{{ membersObj.point.UPOINT.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}P</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel" @mouseup="$emit('savingPoint')">{{ $t('Modal.Membership.Check.msg6') }}</button>
        <button class="btn btn--submit" @mouseup="$emit('usePoint')">{{ $t('Modal.Membership.Check.msg7') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'membersCheck',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {},
  props: {
    currUnitText: String,
    membersObj: Object,
  },
  methods: {},
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
  updated() {
    this.$showButtonAnimation();
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style scoped>
.lyr-center {
  width: 100%;
}

.lst-order--cash {
  width: 100%;
  margin-top: 2em;
}

.lst-order--cash .point {
  width: 100%;
  height: 100%;
  border: 2px solid var(--border-color);
  border-radius: var(--radius);
}

.lst-order--cash .point dd {
  color: var(--secondary-ft-color);
}
</style>
